import { request } from './client'

/**
 * H2 — the parent survey.
 *
 * 🔴 `context: 'public'`, AND IT IS THE ONLY WRITE IN THIS FOLDER THAT SENDS NO
 * TOKEN. `api.md` §2 lists feedback submit as public, and the row is anonymous
 * by design — no parent, no child, no school. Attaching the parent's token
 * "because we have one" would put an identity on the request that the server
 * deliberately does not store, and would make the endpoint fail for the one
 * audience most likely to answer honestly: a parent who has been logged out.
 */

export interface FeedbackSubmission {
  /** 1-5. The scale is stated by `GET /feedback`; this module does not invent it. */
  rating: number
  /** 0-10, optional. Omitted is a NON-RESPONSE, never a zero. */
  nps?: number
  comment?: string
}

/**
 * ⚠️ THE RESPONSE CARRIES NOTHING BUT AN ACKNOWLEDGEMENT, and the type says so.
 * No id, no echoed comment — a caller that could render what it just sent would
 * be one refactor away from rendering it as HTML.
 */
export function submitFeedback(
  body: FeedbackSubmission,
  signal?: AbortSignal,
): Promise<{ recorded: true }> {
  return request<{ recorded: true }>('/feedback', {
    method: 'POST',
    body,
    context: 'public',
    signal,
  })
}
